<template>
  <nav id="UiLayer" :style="[getMaximizedSizeAndOffset]">
    <Logo v-show="showUI.topLeft"></Logo>
    <ContactButton v-show="onHomePage && showUI.topRight && !isOffline"></ContactButton>
    <ExploreButton v-show="onHomePage && showUI.topRight && !isOffline"></ExploreButton>
    <HotspotLabelsButton v-show="!onHomePage && showUI.bottomLeft" :onHomePage="onHomePage"></HotspotLabelsButton>
    <BackButton v-show="!onHomePage && showUI.bottomLeft"></BackButton>

  </nav>
</template>
<script>
import Logo from "../ui/Logo.vue";
import ContactButton from "../ui/ContactButton.vue";
import ExploreButton from "../ui/ExploreButton.vue";
import HotspotLabelsButton from '../ui/HotspotLabelsButton.vue';
import BackButton from "../ui/BackButton.vue";


export default {
  components: {
    // Ui Components
    Logo,
    ContactButton,
    ExploreButton,
    HotspotLabelsButton,
    BackButton,
  },
  data() {
    return {
      contentHidingUI: [],
    };
  },
  methods: {
    getUIPositionsOfContentType(contentType) {
      return this.contentHidingUI?.find(c => c.contentType === contentType)?.uIPositions;
    }
  },
  mounted() {
    // To hide UI elements overlapped by any open content type:
    // - Create an instance of "Content Hiding UI" in the Umbraco Custom Folder (may exist already)
    // - Add to this any content type together with its overlapping UI corner positions   
    this.contentHidingUI = app.api.PageManager.getCustomComponentFromType("contentHidingUI")?.data.contentUIPositions;
  },
  computed: {
    onHomePage() {
      this.$route;
      return app.api.PageManager.onHomePage();
    },
    getMaximizedSizeAndOffset() {
      return this.$store.getters.getMaximizedSizeAndOffsetValue;
    },
    showUI() {
      this.$route;
      var openComponents = app.api.PageManager.getOpenContentComponents();
      var hidePositions = [];

      openComponents.forEach(component => {

        const positions = this.getUIPositionsOfContentType(component.type);

        if (Array.isArray(positions) && positions.length > 0) {
          hidePositions.push(...positions);
        }
      });

      return {
        topLeft: !hidePositions.includes("Top-Left"),
        topRight: !hidePositions.includes("Top-Right"),
        bottomLeft: !hidePositions.includes("Bottom-Left"),
        bottomRight: !hidePositions.includes("Bottom-Right"),
      }
    },
    isOffline() {
      return (window.location.hostname === "");
    }
  }
}
</script>

<style lang="scss">
#UiLayer {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  button {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    height: 40px;
    width: 40px;
    background: var(--secondary-color);
    border: var(--secondary-color) 2px solid;
    transition-timing-function: ease;
    color: #fff;
    font-size: 14px;
    transition: background-color .3s;

    img {
      width: 32px;
    }

    span {
      position: absolute;
      top: 25px;
      padding-top: 20px;
    }

    &:hover {
      background-color: var(--main-color);
      // transform: scale(1.05);
      color: var(--secondary-color);

      span {
        color: var(--secondary-color);
      }

      svg path {
        fill: var(--secondary-color);
      }
    }
  }

  * {
    pointer-events: all;
  }
}
</style>